<span [ngClass]="{
'text-primary-color': taskStatus === 'utworzone',
'text-warning': taskStatus === 'realizacja',
'text-success': taskStatus === 'zrobione',
'text-danger': taskStatus === 'wstrzymane',
'text-dark': taskStatus === 'zakończone'}">
{{ taskStatus }}</span>
